import React from 'react';
import { Circle, G, Line, Path, Polygon, Rect, Text as SvgText } from 'react-native-svg';
import { DiagramCanvas } from '../DiagramCanvas';
import { FormulaTag } from '../FormulaTag';
import { LeaderLine } from '../LeaderLine';
import { DT } from '../tokens';

/** Output = Input · η — boiler shell, flame, stack losses, supply/return piping. */
export function DiagramBoilerOutput() {
  // Boiler shell
  const bx = 110, by = 75, bw = 130, bh = 120;

  return (
    <DiagramCanvas>
      {/* Shell (cylindrical-look) */}
      <Rect x={bx} y={by} width={bw} height={bh} rx="10" fill={DT.fill} stroke={DT.stroke} strokeWidth="1.8" />
      {/* Tube bundle hint */}
      {[0, 1, 2, 3].map(i => (
        <Line key={i} x1={bx + 20} y1={by + 30 + i * 18} x2={bx + bw - 20} y2={by + 30 + i * 18}
          stroke={DT.stroke} strokeWidth="0.6" opacity={0.4} strokeDasharray="6,3" />
      ))}
      <SvgText x={bx + bw / 2} y={by + bh - 8} fill={DT.desc} fontSize="8" fontFamily={DT.mono} textAnchor="middle">BOILER</SvgText>

      {/* Flame (input) */}
      <Path d={`M${bx + bw / 2 - 14},${by + bh + 22} Q${bx + bw / 2},${by + bh - 4} ${bx + bw / 2 + 14},${by + bh + 22} Q${bx + bw / 2 + 6},${by + bh + 14} ${bx + bw / 2},${by + bh + 24} Q${bx + bw / 2 - 6},${by + bh + 14} ${bx + bw / 2 - 14},${by + bh + 22} Z`}
        fill="#FF6B1A" opacity={0.55} stroke="#FF6B1A" strokeWidth="0.8" />
      <SvgText x={bx + bw / 2} y={by + bh + 38} fill={DT.desc} fontSize="8" fontFamily={DT.mono} textAnchor="middle">burner</SvgText>

      {/* Fuel pipe */}
      <Line x1={bx + bw / 2} y1={by + bh + 40} x2={bx + bw / 2} y2={225} stroke={DT.stroke} strokeWidth="4" />
      <SvgText x={bx + bw / 2 + 24} y={220} fill={DT.varColor} fontSize="8" fontFamily={DT.mono}>fuel in</SvgText>

      {/* Return water (cool, enters) */}
      <Line x1={20} y1={by + 90} x2={bx} y2={by + 90} stroke={DT.stroke} strokeWidth="8" strokeLinecap="square" />
      <Line x1={20} y1={by + 90} x2={bx} y2={by + 90} stroke="rgba(122,170,187,0.55)" strokeWidth="4.5" strokeLinecap="square" />
      <Polygon points={`${bx - 6},${by + 90} ${bx - 14},${by + 86} ${bx - 14},${by + 94}`} fill={DT.arrow} />
      <SvgText x={55} y={by + 82} fill="#7AAABB" fontSize="8" fontFamily={DT.mono} fontWeight="700">return</SvgText>

      {/* Supply water (hot, exits) */}
      <Line x1={bx + bw} y1={by + 40} x2={330} y2={by + 40} stroke={DT.stroke} strokeWidth="8" strokeLinecap="square" />
      <Line x1={bx + bw} y1={by + 40} x2={330} y2={by + 40} stroke="rgba(255,107,26,0.55)" strokeWidth="4.5" strokeLinecap="square" />
      <Polygon points={`326,${by + 40} 318,${by + 36} 318,${by + 44}`} fill={DT.arrow} />
      <SvgText x={290} y={by + 32} fill="#FF6B1A" fontSize="8" fontFamily={DT.mono} fontWeight="700">supply</SvgText>

      {/* Stack (losses up) */}
      <Rect x={bx + bw / 2 - 10} y={30} width={20} height={by - 30} fill={DT.fill} stroke={DT.stroke} strokeWidth="1.4" />
      {[0, 1, 2].map(i => (
        <Path key={i} d={`M${bx + bw / 2 - 6 + i * 6},${28} q-2,-4 0,-8 t0,-6`} fill="none" stroke={DT.dim} strokeWidth="1" opacity={0.7} />
      ))}
      <SvgText x={bx + bw / 2 + 18} y={45} fill={DT.desc} fontSize="8" fontFamily={DT.mono}>stack</SvgText>
      <SvgText x={bx + bw / 2 + 18} y={56} fill={DT.dim} fontSize="7" fontFamily={DT.mono}>(losses)</SvgText>

      {/* η badge */}
      <Rect x={bx + 10} y={by + 6} width={36} height={14} fill="rgba(0,0,0,0.5)" />
      <SvgText x={bx + 28} y={by + 16} fill={DT.varColor} fontSize="9" fontFamily={DT.mono} textAnchor="middle" fontWeight="700">η</SvgText>

      {/* Labels */}
      <LeaderLine x1={bx + bw / 2} y1={220} x2={20} y2={220} varName="Input" desc="BTU/h fuel" anchor="start" />
      <LeaderLine x1={bx + 28} y1={by + 14} x2={20} y2={40} varName="η" desc="combustion eff" anchor="start" />
      <LeaderLine x1={310} y1={by + 40} x2={330} y2={215} varName="Output" desc="BTU/h delivered" anchor="end" />

      <FormulaTag formula="Output = Input · η    (η_combustion typically 0.80–0.95)" />
    </DiagramCanvas>
  );
}
